import { render, staticRenderFns } from "./coupon-package.mpx?vue&type=template&id=37fe3898&scoped=true&component=true&componentId=coupon-package0bbcbfd7"
import script from "./coupon-package.mpx?vue&type=script&lang=js&component=true&componentId=coupon-package0bbcbfd7"
export * from "./coupon-package.mpx?vue&type=script&lang=js&component=true&componentId=coupon-package0bbcbfd7"
import style0 from "./coupon-package.mpx?vue&type=style&index=0&id=37fe3898&lang=scss&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m0bbcbfd7%22%7D&component=true&componentId=coupon-package0bbcbfd7"
import style1 from "./coupon-package.mpx?vue&type=style&index=1&id=37fe3898&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m0bbcbfd7%22%7D&component=true&componentId=coupon-package0bbcbfd7"
import style2 from "./coupon-package.mpx?vue&type=style&index=2&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22m0bbcbfd7%22%7D&component=true&componentId=coupon-package0bbcbfd7"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe3898",
  null
  
)

export default component.exports